import { Button } from '@app/core';
import React from 'react';
import { Participation } from '@app/api';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { Actions } from '../hooks/useParticipationTableActions';

const useStyles = createUseStyles((theme: Theme) => ({
  action: {
    minHeight: 0,
    minWidth: 0,
    '&:hover:not(:disabled)': {
      backgroundColor: 'transparent',
    },
    '&:active:not(:disabled)': {
      backgroundColor: 'transparent',
    },
    '&:focus:not(:disabled)': {
      backgroundColor: 'transparent',
    },
  },
  actionContent: {
    padding: 0,
  },
}));

interface Props {
  action: Actions;
  participation: Participation;
  key: string;
}

export const ActionButton = ({ action, participation, key }: Props) => {
  const classes = useStyles();
  const actionFunction = action.singleAction;

  return (
    <Button
      key={key}
      color={action.color}
      variant="transparent"
      className={classes.action}
      contentClassName={classes.actionContent}
      onClick={() => actionFunction(participation)}
    >
      {action.text}
    </Button>
  );
};
